import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { ProfileScope } from "../scope"
import { getProfileActivityQueryParams } from "./activity-query"

export const ProfileMoleculeReatom = molecule((mol, scope) => {
  const { walletAddress } = scope(ProfileScope)
  const bffApiClient = mol(BffApiClientMolecule)
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  // Create dynamic query params that depend on blockchainsQueryFilter
  const activityQueryParamsAtom = computed(() => {
    const blockchains = blockchainsQueryFilter()
    return getProfileActivityQueryParams(bffApiClient, {
      param: { address: walletAddress },
      blockchains,
    })
  }, "profileActivityQueryParams")

  return { walletAddress, activityQueryParamsAtom }
})
